import { render } from "./Video.vue?vue&type=template&id=d11f837e"
import script from "./Video.vue?vue&type=script&setup=true&lang=js"
export * from "./Video.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paragraphs/Video.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d11f837e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d11f837e', __exports__)) {
    api.reload('d11f837e', __exports__)
  }
  
  module.hot.accept("./Video.vue?vue&type=template&id=d11f837e", () => {
    api.rerender('d11f837e', render)
  })

}


export default __exports__